import { useState } from "react";
import { Link } from "react-router-dom";
import { getStoredToken, isTokenExpired } from "@/types";
import { BrandLogo } from "@/components/shared/common/BrandLogo";

function isLoggedIn(): boolean {
  const token = getStoredToken();
  return !!token && !isTokenExpired(token);
}

export function LandingNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const loggedIn = isLoggedIn();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center">
            <BrandLogo imgClassName="h-10 w-auto" />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#features"
              className="text-sm font-medium text-text-secondary hover:text-near-black transition-colors"
            >
              Features
            </a>
            <a
              href="#pricing"
              className="text-sm font-medium text-text-secondary hover:text-near-black transition-colors"
            >
              Pricing
            </a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            {loggedIn ? (
              <Link
                to="/candidates"
                className="rounded-btn bg-near-black px-5 py-2 text-sm font-medium text-white hover:bg-rausch transition-colors"
              >
                Go to App →
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-sm font-medium text-near-black hover:text-rausch transition-colors"
                >
                  Sign In
                </Link>
                <Link
                  to="/signup"
                  className="rounded-btn bg-rausch px-5 py-2 text-sm font-medium text-white hover:bg-[#e0334f] transition-colors"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>

          <button
            type="button"
            className="md:hidden p-2 rounded-btn text-text-secondary hover:text-near-black"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? (
              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white px-4 py-4 space-y-3">
          <a
            href="#features"
            className="block text-sm font-medium text-text-secondary"
            onClick={() => setMenuOpen(false)}
          >
            Features
          </a>
          <a
            href="#pricing"
            className="block text-sm font-medium text-text-secondary"
            onClick={() => setMenuOpen(false)}
          >
            Pricing
          </a>
          <hr className="border-gray-100" />
          {loggedIn ? (
            <Link
              to="/candidates"
              className="block text-sm font-medium text-rausch"
            >
              Go to App →
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="block text-sm font-medium text-near-black"
              >
                Sign In
              </Link>
              <Link
                to="/signup"
                className="block rounded-btn bg-rausch px-4 py-2 text-sm font-medium text-white text-center"
              >
                Get Started
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
